export default {"src":"/_next/static/media/edit.65b38e9e.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};